<!-- BatchDeleteCouponUserForm.vue -->
 <script setup>
import { computed, ref } from "vue";
import { useCouponUserStore } from "@/stores/useCouponUserStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useCouponUserStore();

// IDs selecionados APENAS da página atual.
// Mantém o mesmo comportamento do BatchDeleteCouponForm: se houver seleção
// acumulada em outras páginas, este modal considera só a visível.
const selectedIdsOnCurrentPage = computed(() => {
  const idsOnPage = store.couponUsers.map((cu) => cu.couponUserId);
  return store.selectedCouponUserIds.filter((id) => idsOnPage.includes(id));
});

const selectedCount = computed(() => selectedIdsOnCurrentPage.value.length);

// Congela ao abrir para não trocar o texto quando a store limpar seleção.
const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

const messageTitle = computed(() => {
  if (frozenCount.value === 1)
    return "Tem certeza que deseja apagar o vínculo selecionado?";
  return `Tem certeza que deseja apagar os ${frozenCount.value} vínculos selecionados?`;
});

function buildBatchDeleteError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir os vínculos."
  );
}

async function onConfirmBatchDelete() {
  try {
    await store.deleteSelectedCouponUsers();

    emit("notify", {
      type: "success",
      message:
        frozenCount.value === 1
          ? "Vínculo apagado com sucesso."
          : "Vínculos apagados com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildBatchDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Vínculos em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="Os vínculos selecionados serão apagados. Como alternativa, considere revogar individualmente (preservando o histórico). Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>